import Home from '@/src/components/Public/Home/_Home/Home';
import type { InferGetServerSidePropsType, NextPage } from 'next';
import styles from './index.module.scss';

const HomePage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
    return (
        <>
            <main className={styles.main}>
                <Home />
            </main>
        </>
    );
};

export async function getServerSideProps(context: any) {
    return {
        props: {},
    };
}

export default HomePage;
